"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pclnDesignSystem = require("pcln-design-system");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _CardSection = _interopRequireDefault(require("../../../structure/CardSection"));

var _PriceDisplay = _interopRequireDefault(require("../PriceDisplay"));

var _SavingsBanner = _interopRequireDefault(require("../SavingsBanner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NoWrapFlex = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-16pzeqp-0"
})(["white-space:nowrap;"]);

function SummaryOfChargesHotelItem(_ref) {
  var className = _ref.className,
      title = _ref.title,
      price = _ref.price,
      strikethroughPrice = _ref.strikethroughPrice,
      currencyCode = _ref.currencyCode,
      currencySymbol = _ref.currencySymbol,
      adults = _ref.adults,
      children = _ref.children,
      benefits = _ref.benefits,
      rateProviderText = _ref.rateProviderText,
      savedAmount = _ref.savedAmount,
      exclusiveDealFootnote = _ref.exclusiveDealFootnote,
      estimatedFootnote = _ref.estimatedFootnote,
      cugColor = _ref.cugColor;
  return _react["default"].createElement(_CardSection["default"], {
    className: className
  }, savedAmount > 0 && _react["default"].createElement(_pclnDesignSystem.Flex, {
    mb: 3
  }, _react["default"].createElement(_SavingsBanner["default"], {
    backgroundColor: cugColor || '#87000A',
    savedAmount: savedAmount,
    currencyCode: currencyCode,
    currencySymbol: currencySymbol,
    estimatedFootnote: estimatedFootnote
  })), _react["default"].createElement(_pclnDesignSystem.Flex, null), _react["default"].createElement(_pclnDesignSystem.Flex, {
    justifyContent: "space-between",
    alignItems: "flex-start"
  }, _react["default"].createElement(_pclnDesignSystem.Flex, {
    flexDirection: "column"
  }, _react["default"].createElement(_pclnDesignSystem.Text, {
    bold: true
  }, title), renderBenefits(benefits, exclusiveDealFootnote), renderGuests(adults, children), _react["default"].createElement(_pclnDesignSystem.Text, {
    color: "#5D6A7E",
    fontSize: 0,
    mt: 2
  }, rateProviderText)), _react["default"].createElement(_pclnDesignSystem.Flex, {
    pl: 2
  }, _react["default"].createElement(_PriceDisplay["default"], {
    price: price,
    prefixCurrencyText: currencySymbol,
    strikethroughPrice: strikethroughPrice,
    suffixCurrencyText: currencyCode === 'USD' ? '' : currencyCode,
    timePeriod: "night",
    alignItems: "right"
  }))));
}

var renderGuests = function renderGuests(adults, children) {
  var adultsText = adults > 1 ? 'adults' : 'adult';
  var childrenText = children > 1 ? 'children' : 'child';
  return adults > 0 && children > 0 && _react["default"].createElement(_pclnDesignSystem.Flex, {
    flexDirection: "column",
    mt: 3
  }, _react["default"].createElement(_pclnDesignSystem.Text, {
    color: "#5D6A7E",
    fontSize: 0,
    bold: true
  }, "GUESTS:"), _react["default"].createElement(_pclnDesignSystem.Text, {
    color: "#001832",
    fontSize: 1
  }, adults, " ", adultsText, ", ", children, " ", childrenText));
};

var renderBenefits = function renderBenefits(benefits, exclusiveDealFootnote) {
  return benefits && _react["default"].createElement(NoWrapFlex, {
    flexDirection: "column",
    mt: 3
  }, _react["default"].createElement(_pclnDesignSystem.Flex, {
    alignItems: "center",
    mb: 1
  }, _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: benefits.icon,
    color: benefits.color,
    size: 16
  }), _react["default"].createElement(_pclnDesignSystem.Text, {
    fontSize: 1,
    color: benefits.color,
    bold: true,
    ml: 1,
    pr: 1
  }, benefits.title), exclusiveDealFootnote && _react["default"].createElement(_pclnDesignSystem.Text, {
    color: "#5D6A7E",
    fontSize: 2
  }, exclusiveDealFootnote)), benefits.perks.map(function (perk, index) {
    return _react["default"].createElement(_pclnDesignSystem.Flex, {
      key: index,
      alignItems: "center"
    }, _react["default"].createElement(_pclnDesignSystem.Icon, {
      name: "Check",
      color: benefits.color,
      size: 12
    }), _react["default"].createElement(_pclnDesignSystem.Text, {
      color: "#001832",
      fontSize: 0,
      ml: 2
    }, perk));
  }));
};

SummaryOfChargesHotelItem.displayName = 'SummaryOfChargesHotelItem';
SummaryOfChargesHotelItem.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  price: _propTypes["default"].number.isRequired,
  strikethroughPrice: _propTypes["default"].number,
  currencyCode: _propTypes["default"].string,
  currencySymbol: _propTypes["default"].string,
  adults: _propTypes["default"].number,
  children: _propTypes["default"].number,
  benefits: _propTypes["default"].shape({
    icon: _propTypes["default"].string,
    title: _propTypes["default"].string,
    color: _propTypes["default"].string,
    perks: _propTypes["default"].arrayOf(_propTypes["default"].string)
  }),
  rateProviderText: _propTypes["default"].string,
  savedAmount: _propTypes["default"].number,
  exclusiveDealFootnote: _propTypes["default"].string,
  estimatedFootnote: _propTypes["default"].string,
  cugColor: _propTypes["default"].string
};
SummaryOfChargesHotelItem.defaultProps = {
  className: '',
  currencySymbol: '$',
  currencyCode: 'USD'
};

var _default = (0, _react.memo)(SummaryOfChargesHotelItem);

exports["default"] = _default;